// extracted by mini-css-extract-plugin
export default {"Loading":"Loading__hyRjM1p7bcKR"};